export default __webpack_public_path__ + "static/media/Employees_LEFS.ff013dca.pdf";